import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faHome,
    faNewspaper,
    faBars,
    faCalendar,
    faEnvelope,
    faColumns,
    faPager,
    faGears,
    faChevronDown,
    faMapLocationDot,
    faSearch,
    faEllipsisV,
    faBuilding,
    faForward,
    faSitemap,
    faBridge,
    faPenSquare,
    faTh,
    faFileSignature,
    faUsers,
    faDiagramProject,
    faChevronUp,
    faTimes,
    faFileExport,
    faDownload,
    faUpload,
    faBullhorn,
    faMagicWandSparkles,
    faFileCircleCheck,
    faFilePen,
    faWallet,
    faChartPie,
    faArrowAltCircleRight,
    faLayerGroup,
    faPrint,
    faFileEdit,
    faBookOpen
} from '@fortawesome/free-solid-svg-icons'
import {
    faEye,
    faEyeSlash
} from '@fortawesome/free-regular-svg-icons'

export default function() {
    library.add(faHome);
    library.add(faBars);
    library.add(faPager);
    library.add(faGears);
    library.add(faChevronDown);
    library.add(faChevronUp);
    library.add(faColumns);
    library.add(faNewspaper);
    library.add(faCalendar);
    library.add(faEnvelope);
    library.add(faMapLocationDot);
    library.add(faSearch);
    library.add(faEllipsisV);
    library.add(faEye);
    library.add(faEyeSlash);
    library.add(faBuilding);
    library.add(faForward);
    library.add(faSitemap);
    library.add(faBridge);
    library.add(faTh);
    library.add(faPenSquare);
    library.add(faFileSignature);
    library.add(faUsers);
    library.add(faDiagramProject);
    library.add(faTimes);
    library.add(faFileExport);
    library.add(faDownload);
    library.add(faUpload);
    library.add(faBullhorn);
    library.add(faMagicWandSparkles);
    library.add(faFileCircleCheck);
    library.add(faFilePen);
    library.add(faWallet);
    library.add(faChartPie);
    library.add(faArrowAltCircleRight);
    library.add(faLayerGroup);
    library.add(faPrint);
    library.add(faFileEdit);
    library.add(faBookOpen);
}